// src/components/Loader.jsx
import React from "react";
import "../style/loader.css";
import loaderVideo from "../../assets/FVOL_Video.mp4";

const Loader = () => {
  return (
    <div className="loader-container">
      <video
        className="loader-video"
        src={loaderVideo}
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  );
};

export default Loader;
